const CARD_DIGITS_LENGTH = 16;
export const CARD_BIN_LENGTH = 6;

export const CARD_NUMBER_PLACEHOLDER = '0000 0000 0000 0000';

export const CARD_COMMISSION_VALUE = '0,5%';

export const CARD_COMMISSION_HINT = 'С каждой выплаты на карту берётся комиссия 0,5% за нашу работу';

export const CARD_REVIEW_COMMISSION_HINT = 'С каждой выплаты на карту мы берём комиссию за работу';

export const extractCardDigits = (value: string): string => {
	return value.replace(/\D/g, '').slice(0, CARD_DIGITS_LENGTH);
};

export const extractCardBin = (value: string): string => {
	return extractCardDigits(value).slice(0, CARD_BIN_LENGTH);
};

export const formatCardDisplay = (digits: string): string => {
	const normalized = extractCardDigits(digits);

	if (!normalized) {
		return '';
	}

	return normalized.match(/.{1,4}/g)?.join(' ') ?? normalized;
};

export const isCardNumberValid = (digits: string): boolean => {
	return extractCardDigits(digits).length === CARD_DIGITS_LENGTH;
};
